import React from "react";

import NavigationHeader from "../Navigation/NavigationHeader/NavigationHeader";
import Login from "../../components/authentication/Login/Login";
import classes from "./Layout.css";


const layout = (props) => {

  let content = null;

  if (props.isAuthenticated) {
    // Show the side panel and content
    content =
      (<>
        <main className={classes.content}>
          {props.children}
        </main>
      </>)
  } else {
    // Show the login dialog
    content = (<Login {...props}/>)
  }

  return (
    <>
      <NavigationHeader
        isAuthenticated={props.isAuthenticated}
        isMaintainer={props.isMaintainer}
        username={props.username}
        logout={props.logout}/>
      {content}
    </>
  );
}

export default layout;
